// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"RjeRd__tooltipContainer","questionWrapper":"z5Ukn__questionWrapper","header":"_2Rdrg__header theme-primary-font-border-fade-50"};